// extracted by mini-css-extract-plugin
module.exports = {"listItem":"GeographicList_listItem__NkRUk","listHeader":"GeographicList_listHeader__3aTY4","listFooter":"GeographicList_listFooter__c8DQi"};